var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabaseRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "database-remove-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 13.59V7.5C20 5.29 16.42 3.5 12 3.5C7.58 3.5 4 5.29 4 7.5V17.5C4 19.71 7.59 21.5 12 21.5C12.46 21.5 12.9 21.5 13.33 21.44C13.12 20.83 13 20.18 13 19.5V19.45C12.68 19.5 12.35 19.5 12 19.5C8.13 19.5 6 18 6 17.5V15.27C7.61 16.05 9.72 16.5 12 16.5C12.65 16.5 13.27 16.46 13.88 16.39C14.93 14.66 16.83 13.5 19 13.5C19.34 13.5 19.67 13.54 20 13.59ZM18 12.95C16.7 13.9 14.42 14.5 12 14.5C9.58 14.5 7.3 13.9 6 12.95V10.14C7.47 10.97 9.61 11.5 12 11.5C14.39 11.5 16.53 10.97 18 10.14V12.95ZM12 9.5C8.13 9.5 6 8 6 7.5C6 7 8.13 5.5 12 5.5C15.87 5.5 18 7 18 7.5C18 8 15.87 9.5 12 9.5ZM20.41 19.5L22.54 21.62L21.12 23.04L19 20.91L16.88 23.04L15.47 21.62L17.59 19.5L15.47 17.38L16.88 15.97L19 18.09L21.12 15.97L22.54 17.38L20.41 19.5Z",
    fill: "#D81010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseRemoveIcon);
export default __webpack_public_path__ + "static/media/database-remove-icon.d8424dcf76e106cdfaec050aefce6282.svg";
export { ForwardRef as ReactComponent };